import React, { FC } from 'react'

import { Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import Text from '~/components/shared/Text'

const TemporaryStep: FC = () => {
  return (
    <Box>
      <Box padding="12px">
        <Skeleton width={550} height={50} />
      </Box>
      <Box padding="12px">
        <Skeleton width={550} height={50} />
      </Box>
      <Box padding="12px">
        <Text fontSize={18}>Upload your company logo *</Text>
      </Box>
      <Box padding="12px">
        <Skeleton width={550} height={50} />
      </Box>
      <Box padding="12px">
        <Text fontSize={18}>Description</Text>
      </Box>
      <Box padding="12px">
        <Skeleton width={550} height={248} />
      </Box>
      <Box padding="12px">
        <Skeleton width={185} height={44} />
      </Box>
    </Box>
  )
}

export default TemporaryStep
